import React from 'react';
import { ICoreContext } from '@msdyn365-commerce/core';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import { OrderInfo } from './order-info';
import { OrderError } from './order-error';
import { IPostCreateOrderResponseData } from '../../../actions/post-create-order.action';
import AcknowledgementActionButtons from '../components/acknowledgement-action-buttons';
import OrderItems from './acknowledgement-items-table';
import AddressInformation from '../components/address-information';

interface IAcknowledgementProps {
    context: ICoreContext;
    orderData: IPostCreateOrderResponseData;
    resources: ILxsCreateOrderResources;
    productsHaveEndcustomers: boolean;
}

export default function acknowledgement({ context, orderData, resources, productsHaveEndcustomers }: IAcknowledgementProps) {
    return (
        <div className='row'>
            <div className='col-12'>
                {orderData.Order.OrderNumber === '' ? (
                    <OrderError resources={resources} orderData={orderData} />
                ) : (
                    <>
                        <div className='lxs-create-order__confirmation-alert'>
                            <h1>{resources.createOrderConfirmationAlertTitle}</h1>
                            <span>{resources.createOrderConfirmationAlertHint}</span>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-lg-8'>
                                <OrderInfo orderData={orderData} resources={resources}></OrderInfo>
                            </div>
                            <div className='col-12 col-lg-4 pl-lg-0'>
                                <AddressInformation soldTo={orderData.Order.SoldTo} shipTo={orderData.Order.ShipTo} resources={resources} />
                            </div>
                        </div>
                        <OrderItems
                            context={context}
                            itemsData={orderData}
                            resources={resources}
                            productsHaveEndcustomers={productsHaveEndcustomers}
                        />
                        <div className='col-12'>
                            <AcknowledgementActionButtons context={context} resources={resources} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
